import { ACCOUNT_GROUP_TYPE } from '../../../utils/financialHelper';

const BG_COLORS = {
  INCOME_ITEM: '#e6f4ea',
  INCOME_GROUP: '#d2ecdd',
  INCOME_SUBGROUP: '#bee4d0',
  OUTCOME_ITEM: '#fdecea',
  OUTCOME_GROUP: '#fbd9d6',
  OUTCOME_SUBGROUP: '#f9c6c2',
  RESULT: '#f5f5f5',
};

export const getBackgroundColor = (row) => {
  if (row.type === ACCOUNT_GROUP_TYPE.RESULT) {
    return BG_COLORS.RESULT;
  }

  const typeKey = row.type === ACCOUNT_GROUP_TYPE.INCOME ? 'INCOME' : 'OUTCOME';
  return BG_COLORS[`${typeKey}_${row.level.toUpperCase()}`] || '#fff';
};
